import { useContext, useState } from "react";
import Swal from "sweetalert2";
import { request } from "../../../request";
import { MainContext } from "../../../MainContext";
import AutomationInputs from "./AutomationInputs";

const default_place = {
    place: {
        customerId: null,
        accountId: null,
    },
    currency_name: "",
    amount: 0,
};

const hours = [];
for (let i = 0; i < 24; i++) {
    hours.push(i < 10 ? `0${i}` : `${i}`);
}
const minutes = [];
for (let i = 0; i < 60; i++) {
    minutes.push(i < 10 ? `0${i}` : `${i}`);
}

const AddAutomation = ({ fetchData }) => {
    const [inputs, setInputs] = useState([default_place, default_place]);
    const { darkMode, updateAccounts, updateCapital } = useContext(MainContext);
    const [days, setDays] = useState(30);
    const [date, setDate] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            for (const input of inputs) {
                if (input.amount <= 0 && input.place.accountId) {
                    Swal.fire("Amount should be more than 0");
                }
            }
            const newTransaction = {
                from: inputs[0],
                to: inputs[1],
                interval: days * 60 * 60 * 1000,
                startFrom: new Date(date).getTime(),
            };

            await request.post("/automation/", newTransaction);
            Swal.fire({
                title: "Automation added successfully",
                icon: "success",
            });
            fetchData();
        } catch (error) {
            console.log(error);
        }
    };

    const updateInputs = (index, value) => {
        const newValue = { ...value };
        let prevAccountIndex = undefined;
        for (let i = index - 1; i > -1; i--) {
            if (inputs[i]?.place.accountId) {
                prevAccountIndex = i;
                break;
            }
        }
        if (prevAccountIndex !== undefined) {
            if (newValue.avg !== inputs[index].avg && index > 0) {
                newValue.amount = inputs[prevAccountIndex].amount / newValue.avg;
            }
            if (newValue.amount !== inputs[index].amount && index > 0) {
                newValue.avg = (inputs[prevAccountIndex].amount / newValue.amount)?.toFixed(6);
            }
        }
        const updatedInputs = [...inputs];
        if (isNaN(newValue.amount)) {
            newValue.amount = inputs[index].amount;
        }
        if (isNaN(newValue.avg)) {
            newValue.avg = inputs[index].avg?.toFixed(6);
        }
        updatedInputs[index] = newValue;
        setInputs(updatedInputs);
    };

    const getPlaceInputLabel = (index) => {
        if (!index) return "From: ";
        else if (index === inputs.length - 1) return "To: ";
        else if (inputs.length === 3) return "Through: ";
        else return `Through ${index}: `;
    };

    const handleDateChange = (e) => {
        const newDate = new Date(e.target.value);
        if (date) {
            newDate.setHours(date?.getHours());
        }
        setDate(newDate);
    };

    const handleHourChange = (e) => {
        const newHour = parseInt(e.target.value, 10);
        if (date) {
            const updatedDate = new Date(date);
            updatedDate.setHours(newHour);
            setDate(updatedDate);
        }
    };

    const handleMinChange = (e) => {
        const newMin = parseInt(e.target.value, 10);
        if (date) {
            const updatedDate = new Date(date);
            updatedDate.setMinutes(newMin);
            setDate(updatedDate);
        }
    };
    return (
        <div className="container mx-auto p-6 max-w-[960px] bg-white border border-gray-300 rounded-lg shadow-lg" style={{ backgroundColor: darkMode ? "#141619" : "white" }}>
            <form className="mb-4" onSubmit={handleSubmit}>
                {inputs.map((input, index) => (
                    <div className="flex items-center justify-between mb-3 px-15">
                        <AutomationInputs label={getPlaceInputLabel(index)} values={input} setValues={(newValue) => updateInputs(index, newValue)} noCustomers={inputs[index - 1]?.place.customerId} />
                        {inputs.length > 2 && (
                            <button
                                type="button"
                                class="flex min-w-[84px] max-w-[480px] mb-2 text-xs cursor-pointer items-center justify-center overflow-hidden rounded-xl h-10 px-4 bg-[#f0f2f4] text-[#111418] font-bold leading-normal tracking-[0.015em]"
                                style={{
                                    backgroundColor: darkMode ? "#5d5d5d" : "#5d5d5d",
                                    color: "white",
                                }}
                            >
                                <span class="truncate">X</span>
                            </button>
                        )}
                    </div>
                ))}
                <h1 className="text-lg font-bold leading-normal tracking-[0.015em]" style={{ color: darkMode ? "white" : "black" }}>
                    Enter Interval
                </h1>
                <div className="flex flex-col py-3">
                    <label className="text-lg font-bold leading-normal tracking-[0.015em]" htmlFor="name">
                        <input
                            type="text"
                            id="name"
                            value={days}
                            onChange={(e) => (!isNaN(parseInt(e.target.value)) ? setDays(parseInt(e.target.value)) : setDays(0))}
                            className="form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-xl text-[#111418] focus:outline-0 focus:ring-0 border border-[#dce0e5] bg-white focus:border-[#dce0e5] h-14 placeholder:text-[#637588] p-[15px] text-base font-normal leading-normal"
                            placeholder="Enter days"
                            required
                        />
                    </label>
                </div>
                <h1 className="text-lg font-bold leading-normal tracking-[0.015em] mt-3" style={{ color: darkMode ? "white" : "black" }}>
                    Enter Start Date
                </h1>
                <div className="flex flex-col">
                    <label className="sm:flex grid text-lg font-bold leading-normal tracking-[0.015em] flex mb-5 py-3 " htmlFor="name">
                        <input
                            type="date"
                            onChange={handleDateChange}
                            className="sm:w-30 w-[225px] mr-5 form-input flex min-w-0 flex-1 resize-none overflow-hidden rounded-xl text-[#111418] focus:outline-0 focus:ring-0 border border-[#dce0e5] bg-white focus:border-[#dce0e5] h-14 placeholder:text-[#637588] p-[15px] text-base font-normal leading-normal"
                            placeholder="Choose date"
                            required
                        />
                        <select
                            id={`dropdown`}
                            className="mr-5 appearance-none sm:w-20 w-[225px] mt-3 sm:mt-0 h-14 px-4 py-2 text-base text-gray-800 bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all ease-in-out duration-150 hover:shadow-lg"
                            onChange={handleHourChange}
                        >
                            <option value="">Hour</option>
                            {hours.map((value) => (
                                <option key={value} value={value} onChange={(e) => date.setHours(value)}>
                                    {value}
                                </option>
                            ))}
                        </select>
                        <select
                            id={`dropdown`}
                            className="appearance-none sm:w-20 w-[225px] mt-3 sm:mt-0 h-14 px-4 py-2 text-base text-gray-800 bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all ease-in-out duration-150 hover:shadow-lg"
                            onChange={handleMinChange}
                        >
                            <option value="">Min.</option>
                            {minutes.map((value) => (
                                <option
                                    key={value}
                                    // value={}
                                >
                                    {value}
                                </option>
                            ))}
                        </select>
                    </label>
                </div>
                <button
                    type="submit"
                    class="flex min-w-[84px] max-w-[480px] mt-8 cursor-pointer items-center justify-center overflow-hidden rounded-xl h-10 px-4 bg-[#f0f2f4] text-[#111418] text-sm font-bold leading-normal tracking-[0.015em]"
                    style={{
                        backgroundColor: darkMode ? "#FEC901" : "#C1C1C1",
                    }}
                >
                    <span class="truncate">Add New Automation</span>
                </button>
            </form>
        </div>
    );
};

export default AddAutomation;
